// Generated by Melange

import LoginPageModuleCss from "./loginPage.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Fetch from "melange-fetch/Fetch.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Js__Js_exn from "melange.js/js_exn.jsx";
import * as LucideReact from "../lucideReact/lucideReact.jsx";
import * as Shared__Button from "../shared/button.jsx";
import * as Shared__Footer from "../shared/footer.jsx";
import * as Shared__Input from "../shared/input.jsx";
import * as Shared__Label from "../shared/label.jsx";
import * as Shared__Logo from "../shared/logo.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Int from "melange/int.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__Context from "../store/context.jsx";
import * as Subsonic__Ping from "../api/subsonic/ping.jsx";
import * as Webapi__Dom__HtmlInputElement from "melange-webapi/Webapi/Dom/Webapi__Dom__HtmlInputElement.jsx";
import * as LucideReact$1 from "lucide-react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as SparkMd5 from "spark-md5";

const css = LoginPageModuleCss;

function LoginPage(Props) {
  const saveSubsonicCredentials = Store__Context.useAppStore(function (state) {
    return state.auth.saveSubsonicCredentials;
  });
  const match = React.useState(function () {
    return Stdlib__Fun.$$const(false, undefined);
  });
  const setIsLoginSubmitting = match[1];
  const isLoginSubmitting = match[0];
  const partial_arg = {
    TAG: /* Ok */ 0,
    _0: undefined
  };
  const match$1 = React.useState(function () {
    let param;
    return Stdlib__Fun.$$const(partial_arg, param);
  });
  const setLoginResult = match$1[1];
  const loginResult = match$1[0];
  const handleSubmit = function ($$event) {
    $$event.preventDefault();
    Curry._1(setIsLoginSubmitting, (function (param) {
      return Stdlib__Fun.$$const(true, param);
    }));
    const formData = new FormData($$event.currentTarget);
    const input = function (name) {
      const entry = Curry._1(Fetch.$$FormData.EntryValue.classify, Stdlib__Option.get(formData.get(name)));
      if (entry.NAME === "File") {
        return Js__Js_exn.raiseError("Expected a string");
      } else {
        return entry.VAL;
      }
    };
    const password = input("password");
    const serverBaseUrl = input("server-base-url");
    const username = input("username");
    const salt = Array.from(crypto.getRandomValues(new Uint8Array(3))).map(function (b) {
      return b.toString(16);
    }).join("");
    const token = SparkMd5.hash(password + salt, false);
    const credentials = {
      salt: salt,
      serverBaseUrl: serverBaseUrl,
      token: token,
      username: username
    };
    Fx.runAsync(Fx.map(Subsonic__Ping.make(undefined), (function (param) {
      Curry._1(saveSubsonicCredentials, credentials);
    })), {
      credentials: credentials
    }).then(function (result) {
      Curry._1(setLoginResult, (function (param) {
        return Stdlib__Fun.$$const(result, param);
      }));
      Curry._1(setIsLoginSubmitting, (function (param) {
        return Stdlib__Fun.$$const(false, param);
      }));
      return Promise.resolve(undefined);
    });
  };
  const credentials = Store__Context.useAppStore(function (state) {
    return state.auth.credentials;
  });
  let message;
  if (loginResult.TAG === /* Ok */ 0) {
    message = undefined;
  } else {
    const error = loginResult._0;
    if (/* tag */ typeof error === "number" || typeof error === "string") {
      message = error === /* NetworkError */ 1 ? "Network error occurred. Please check your network connection" : "Unexpected API response";
    } else {
      switch (error.TAG) {
        case /* RequestFailed */ 0 :
          message = Stdlib__Int.to_string(error.status) + (": " + error.statusText);
          break;
        case /* ApiError */ 2 :
          message = error.message;
          break;
        default:
          message = "Unexpected API response";
      }
    }
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("main", {
        children: JsxRuntime.jsxs("form", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Shared__Logo.make, {
                      className: css.logoSvg
                    }),
                    JsxRuntime.jsx("strong", {
                      children: "Violette",
                      "aria-hidden": true
                    })
                  ],
                  className: css.logo
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    "Enter your server details or ",
                    JsxRuntime.jsx("button", {
                      children: "try a demo",
                      className: css.demoLink,
                      type: "button",
                      onClick: (function ($$event) {
                        const form = $$event.currentTarget.form;
                        const input = function (name) {
                          return Stdlib__Option.get(Stdlib__Option.bind(Caml_option.nullable_to_opt(form.elements.namedItem(name)), Webapi__Dom__HtmlInputElement.ofElement));
                        };
                        input("server-base-url").value = "https://demo.navidrome.org";
                        input("username").value = "demo";
                        input("password").value = "demo";
                        form.requestSubmit();
                      })
                    })
                  ],
                  className: css.description,
                  id: "login-form-description"
                })
              ],
              className: css.header
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Shared__Label.make, {
                      children: "URL:",
                      className: css.label,
                      htmlFor: "login-server-base-url"
                    }),
                    JsxRuntime.jsx(Shared__Input.make, {
                      autoFocus: true,
                      defaultValue: Stdlib__Option.value(Stdlib__Option.map((function (x) {
                        return x.serverBaseUrl;
                      }), credentials), ""),
                      disabled: isLoginSubmitting,
                      id: "login-server-base-url",
                      name: "server-base-url",
                      required: true,
                      type_: "url"
                    })
                  ]
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Shared__Label.make, {
                      children: "Username:",
                      className: css.label,
                      htmlFor: "login-username"
                    }),
                    JsxRuntime.jsx(Shared__Input.make, {
                      autoComplete: "username",
                      defaultValue: Stdlib__Option.value(Stdlib__Option.map((function (x) {
                        return x.username;
                      }), credentials), ""),
                      disabled: isLoginSubmitting,
                      id: "login-username",
                      name: "username",
                      required: true
                    })
                  ]
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Shared__Label.make, {
                      children: "Password:",
                      className: css.label,
                      htmlFor: "login-password"
                    }),
                    JsxRuntime.jsx(Shared__Input.make, {
                      autoComplete: "current-password",
                      disabled: isLoginSubmitting,
                      id: "login-password",
                      name: "password",
                      required: true,
                      type_: "password"
                    })
                  ]
                })
              ],
              className: css.fields
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs(Shared__Button.make, {
                  children: [
                    JsxRuntime.jsx(LucideReact$1.KeyRound, Curry._4(LucideReact.KeyRound.makeProps, true, undefined, undefined, undefined)),
                    "Login"
                  ],
                  disabled: isLoginSubmitting,
                  loading: isLoginSubmitting,
                  type_: "submit"
                }),
                message !== undefined ? JsxRuntime.jsx("p", {
                    children: message,
                    className: css.submitError,
                    role: "alert"
                  }) : null
              ],
              className: css.submitButtonWrapper
            })
          ],
          "aria-describedby": "login-form-description",
          "aria-labelledby": "login-form-heading",
          className: css.form,
          onSubmit: handleSubmit
        }),
        className: css.inner
      }),
      JsxRuntime.jsx(Shared__Footer.make, {})
    ],
    className: css.root
  });
}

const make = LoginPage;

export {
  make,
}
/* css Not a pure module */
